export const numberShorter = (value: number, fixed = 0) => {
  const schema = ['', 'тыс.', 'млн.'];
  const index = Math.floor(Math.log10(value) / 3);

  return (
    (value / 10 ** (3 * index)).toFixed(fixed) +
    (schema[index] === undefined ? ` ${index * 3}` : ` ${schema[index]}`)
  );
};
